/**
 * URL del portal donde el asociado ingresa o actualiza sus datos.
 * Definir VITE_ASSOCIATE_PORTAL_URL en .env para otro entorno.
 */
export const ASSOCIATE_PORTAL_URL =
  import.meta.env.VITE_ASSOCIATE_PORTAL_URL?.trim() ||
  'http://192.99.179.93:9061/usuarios/login/';
